import Input from './Input';
import RadioGroup from './RadioGroup';
import Select from './Select';
import Checkbox from './Checkbox';
import DatePicker from './DatePicker';
import DatePickerNew from './DatePickerNew';
import Button from './Button';
import ActionButton from './ActionButton';
import Autocomplete from './Autocomplete';
import NumericInput from './NumericInput';
import NumericInputNew from './NumericInputNew';
import Textarea from './Textarea';
import TimePicker from './TimePicker';
import TabPanel from './TabPanel';
import AutocompleteWider from './AutocompleteWider';

export const Controls = {
    Input,
    RadioGroup,
    Select,
    Checkbox,
    DatePicker,
    DatePickerNew,
    Button,
    ActionButton,
    Autocomplete,
    AutocompleteWider,
    NumericInput,
    NumericInputNew,
    Textarea,
    TimePicker,
    TabPanel,
};
